export const GET_ALL_ERRORS = '@@Elastic/GET_ALL_ERRORS';
export const GET_TEST_ERRORS = '@@Elastic/GET_TEST_ERRORS';
